import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function fetchCatDomains({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/cat-domains`, { params: filters })
    .then(res => (
      dispatch('setCatSubjectDomains', {
        catSubjectDomains: res.data,
        subjectId: filters.subject_id,
      })
    ));
}

export function setCatSubjectDomains({ commit }, { subjectId, catSubjectDomains }) {
  commit(types.SET_CAT_SUBJECT_DOMAINS, { subjectId, catSubjectDomains });

  return Promise.resolve(catSubjectDomains);
}

export function resetCatSubjectDomains({ commit }) {
  commit(types.RESET_CAT_SUBJECT_DOMAINS);
}

export function fetchCatStats({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/users/cl-cat-stats`, { params: filters })
    .then(res => (
      dispatch('setCatStats', {
        catStats: res.data,
        subjectId: filters.subject_id,
      })
    ));
}

export function setCatStats({ commit }, { subjectId, catStats }) {
  commit(types.SET_CAT_STATS, { subjectId, catStats });

  return Promise.resolve(catStats);
}



// WEBPACK FOOTER //
// ./src/app/cat-domain/store/actions.js